import { GLOBAL } from 'store/actions/types'
import { store } from 'store'
import Api from 'common/Api'

export const getContacts = (payload) => {
    const pagination = store.getState().global.contactsListPagination
    const params = {
        page: payload?.params?.page || pagination.page,
        limit: payload?.params?.limit || pagination.limit
    }
    const contactsFilterValue = payload.requestValue

    return (dispatch) => {
        dispatch({
            type: GLOBAL.GET_CONTACTS,
            payload
        })

        if (payload.requestValue) {
            dispatch({
                type: GLOBAL.GET_FILTERED_CONTACTS,
                payload
            })
        }

        return Api.getContacts(contactsFilterValue, params)
            .then((response) => {
                if (contactsFilterValue) {
                    dispatch(getContactsFilteredSuccess(response.data || []))
                } else {
                    dispatch(getContactsFilteredSuccess([]))
                    dispatch(getContactsSuccess(response.data || []))
                }
            })
            .catch((error) => {
                dispatch(getContactsFail(error))
            })
    }
}

export const requestContactStart = () => ({
    type: GLOBAL.REQUEST_CONTACTS_START
})

export const requestContactFinish = () => ({
    type: GLOBAL.REQUEST_CONTACTS_FINISH
})

export const getContactsSuccess = (payload) => ({
    type: GLOBAL.GET_CONTACTS_SUCCESS,
    payload
})

export const getContactsFail = (payload) => ({
    type: GLOBAL.GET_CONTACTS_FAIL,
    payload
})

export const getContactsFilteredSuccess = (payload) => ({
    type: GLOBAL.GET_CONTACTS_FILTERED_SUCCESS,
    payload
})

export const getContactsFilteredFail = (payload) => ({
    type: GLOBAL.GET_CONTACTS_FILTERED_FAIL,
    payload
})

export const getRecents = (payload) => {
    const { offset, limit: take, period } = payload

    return async (dispatch) => {
        dispatch({
            type: GLOBAL.GET_RECENTS,
            payload
        })
        
        try {
            const response = await Api.getRecentCalls({ take, offset, period })
            if(response.status !== 200) throw new Error(`Response status is ${response.status}`)
            dispatch(getRecentsSuccess({...payload, ...response.data, reqPeriod: period } || []))
        } catch (error) {
            dispatch(getRecentsFail(error))
        }
    }
}

export const resetRecents = (payload) => ({
    type: GLOBAL.RESET_RECENTS,
    payload
})

export const getRecentsSuccess = (payload) => ({
    type: GLOBAL.GET_RECENTS_SUCCESS,
    payload
})

export const getRecentsFail = (payload) => ({
    type: GLOBAL.GET_RECENTS_FAIL,
    payload
})

export const getLastCall = (payload) => {
    return (dispatch) => {
        dispatch({
            type: GLOBAL.GET_LAST_CALL,
            payload
        })
        return Api.getLastCall()
            .then((response) => {
                const { lastCall, success } = response.data
                if(!success) return
                dispatch(getLastCallSuccess({ number: lastCall }))
            })
            .catch((error) => {
                dispatch(getLastCallFail(error))
            })
    }
}

export const setLastCall = (payload) => {
    return (dispatch) => {
        dispatch(getLastCallSuccess({ number: payload }))
    }
}

export const getLastCallSuccess = (payload) => ({
    type: GLOBAL.GET_LAST_CALL_SUCCESS,
    payload
})

export const getLastCallFail = (payload) => ({
    type: GLOBAL.GET_LAST_CALL_FAIL,
    payload
})

export const getDids = (payload) => {
    const pagination = store.getState().global.contactsListPagination
    const params = {
        page: payload?.params?.page || pagination.page,
        limit: payload?.params?.limit || pagination.limit
    }
    return (dispatch) => {
        dispatch({
            type: GLOBAL.GET_DIDS,
            payload
        })
        return Api.getDidNumbers(params)
            .then((response) => {
                dispatch(getDidsSuccess(response.data || []))
            })
            .catch((error) => {
                dispatch(getDidsFail(error))
            })
    }
}

export const getDidsSuccess = (payload) => ({
    type: GLOBAL.GET_DIDS_SUCCESS,
    payload
})

export const getDidsFail = (payload) => ({
    type: GLOBAL.GET_DIDS_FAIL,
    payload
})

export const setInternetConnectionLost = (payload) => ({
    type: GLOBAL.SET_INTERNET_CONNECTION_LOST,
    payload
})

export const setMicrophonePermissionDenied = (payload) => ({
    type: GLOBAL.SET_MICRO_PHONE_PERMISSION_DENIED,
    payload
})

export const setMultipleTabs = (payload) => ({
    type: GLOBAL.SET_MULTIPLE_TABS,
    payload
})

export const setNotificationPermissionDenied = (payload) => ({
    type: GLOBAL.SET_NOTIFICATION_PERMISSION_DENIED,
    payload
})

export const setContactsModalVisible = (payload) => ({
    type: GLOBAL.SET_CONTACTS_MODAL_VISIBLE,
    payload
})

export const setTransferModalVisible = (payload) => ({
    type: GLOBAL.SET_TRANSFER_MODAL,
    payload
})

export const setKeypadModalVisible = (payload) => ({
    type: GLOBAL.SET_KEYPAD_MODAL_VISIBLE,
    payload
})

export const toggleKeypadModalVisible = () => {
    const keypadModalVisible = store.getState().global.keypadModalVisible
    return {
        type: GLOBAL.SET_KEYPAD_MODAL_VISIBLE,
        payload: !keypadModalVisible
    }
}

export const closeAllModals = () => {
    return {
        type: GLOBAL.CLOSE_ALL_MODALS
    }
}

export const setError = (payload) => ({
    type: GLOBAL.ERROR,
    payload
})

export const setAlert = (payload) => ({
    type: GLOBAL.ALERT,
    payload
})

export const setAppStartAudioPlayed = () => ({ type: GLOBAL.SET_APP_START_AUDIO_PLAYED })

export const setTabId = (payload) => ({
    type: GLOBAL.SET_TAB_ID,
    payload
})
